module.exports = __webpack_public_path__ + "img/n5.8151e586.png";